export default "__VITE_ASSET__Bvi7O8rn__"